<div class="gocam-container docs">
  <app-page-contents-menu title="GO-CAM pathways" titleRoute="/gocam">

    <div class="left-menu-part left-menu-item"><a routerLink="/gocam/model-list">Pathway list</a></div>
    <div class="left-menu-part left-menu-item"><span>Summary map</span></div>
    <div class="left-menu-part left-sub-menu-item"><a routerLink="/gocam/summary/all">All pathways</a></div>
    <div class="left-menu-part left-sub-menu-item"><a routerLink="/gocam/summary/connected">Connected pathways</a></div>
    <div class="left-menu-part left-menu-item"><span>Mega Model</span></div>
    <div class="left-menu-part left-sub-menu-item"><a routerLink="/gocam/mega-model/all">All pathways</a></div>
    <div class="left-menu-part left-sub-menu-item"><a routerLink="/gocam/mega-model/connected">Connected pathways</a></div>
    <div class="left-menu-part left-menu-item"><a routerLink="/gocam/tools">Pathway tools</a></div>
    <div class="left-menu-part left-menu-item"><a routerLink="/gocam/pathway-metrics">Pathway metrics</a></div>
    <div class="left-menu-part left-menu-item"><a routerLink="/gocam/missing-activities">Missing activities</a></div>
    <div class="left-menu-part left-menu-item"><a routerLink="/gocam/connections">Pathway joining activities</a></div>

  </app-page-contents-menu>

  <div class="docs-content">

  <div *ngIf="pageType == 'front'" class="gocam-landing-page">
    <h3>{{siteName}} GO-CAM pathways
      <span class="help-link">
      <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
        Documentation
      </app-help-link>
    </span></h3>
    <div class="description">
GO-CAMs (Gene Ontology Causal Activity Models) are a framework
developed by the Gene Ontology (GO) project to represent complex
biological pathways in a structured, computable format. They model how
molecular activities, enabled by gene products or complexes, are
causally linked to form larger biological processes.
    </div>
    <div class="description">
Creating a comprehensive GO-CAM representation of a eukaryotic cell is
an ambitious and ongoing project.  We therefore welcome community
input to help improve, expand, or correct the current pathway models. If you
have subject area knowledge on a specific pathway also please consider
contacting us to provide feedback on accuracy and completeness.
    </div>
    <div class="description">
Visit the <a routerLink="/gocam/model-list">GO-CAM pathway list</a>.
    </div>
    <div class="description">
    For more information, visit the
    <a routerLink="/documentation/gocams">PomBase GO-CAM documentation</a> or
    the <a href="https://geneontology.org/docs/gocam-overview/">Gene Ontology project's GO-CAM overview</a>.
    </div>

    <div class="project-scope">
      <app-gocam-project-scope></app-gocam-project-scope>
    </div>


    <h4>Summary Map</h4>
<div class="docs-image-flex">
<a routerLink="/gocam/summary/connected">
<img src="assets/gocam-docs-summary-map.png" class="screenshot docs-left-float" loading="lazy"/>
</a>

<div style="display: inline-block">
The <b>Summary Map</b> provides a high-level, visual overview of how
individual GO-CAM pathways are causally connected, without showing the
internal structure of particular models.

    <h5>The "All Models Summary Map"</h5>
Displays a connected Summary Map, but also includes the set of models
that are not yet causally linked to any other model
<p>
<a routerLink="/gocam/summary/all">View All Models Summary Map</a>

    <h5>The "Connected Summary Map"</h5>
Displays curated causal connections between GO-CAM pathways (inter-model connections)
<p>
<a routerLink="/gocam/summary/connected">View Connected Summary Map</a>

<p>
The maps are fully interactive:

<ul>
  <li>Click on a pathway to view the title of the GO-CAM in the
    right-hand panel</li>
  <li>Click on the pathway title to open a new tab/window to visit
    a detailed view</li>
  <li>Multiple pathways can be selected by shift-clicking or shift-click and
    drag in the map
    <ul>
      <li>
        When multiple pathways are selected, click on "View
        joined models" to see connections between the models in detail
      </li>
    </ul>
  </li>
  <li>Zoom, drag, and rearrange nodes to explore the layout</li>
</ul>

</div>
</div>

   <h4>Mega Model</h4>
<div class="docs-image-flex">
<a routerLink="/gocam/mega-model/all">
<img src="assets/gocam-docs-mega-model.png" class="screenshot docs-left-float" loading="lazy"/>
</a>

<div>
The <b>Mega Model</b> view displays GO-CAMs in full detail, showing all
intra- and inter-model connections.  Initially, chemical
inputs/outputs and target genes are hidden to reduce visual complexity
— but you can toggle them on or off as needed.

    <h5 class="clear-float">The "All Models Mega Model"</h5>
Displays all curated GO-CAM pathways in full detail:
<ul>
  <li>Each model is enclosed by a boundary (by default)</li>
  <li>All intra- and inter-model connections are shown</li>
  <li>Unconnected models are also included</li>
</ul>
<p>
<a routerLink="/gocam/mega-model/all">View All Models Mega Model</a>

<h5>The "Connected Models Mega Model"</h5>

Displays only those GO-CAM pathways that have inter-model connections,
omitting unlinked models.
<p>
<a routerLink="/gocam/mega-model/connected">View Connected Models Mega Model</a>
</div>
</div>

    <h4>Missing activities</h4>
    <div class="description">
We maintain a list of activities (currently {{getMissingActivityCount() | async}}) known or suspected to occur in
fission yeast that are not yet associated with any specific gene
product. These pathway gaps were identified through GO-CAM curation
and highlight areas for further research and annotation.
    </div>

    <div class="description">
    <a routerLink="/gocam/missing-activities">Missing <span class="genus-species">S. pombe</span> activities</a>
    </div>

    <h4>Pathway joining activities</h4>
A curated list of pathway models that share overlapping activities. This list includes:
    <ul>
      <li>The specific activities used to link pathways</li>
      <li>The joined pathways</li>
      <li>Links to views of the joined pathways</li>
    </ul>

    <div class="description">
      <a routerLink="/gocam/connections">View model joining activities</a>
    </div>
  </div>

  <div *ngIf="pageType == 'model-list'" class="gocam-landing-page">
    <h3>Available <span class="genus-species">S. pombe</span> GO-CAM pathways
      <span class="help-link">
      <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
        Documentation
      </app-help-link>
    </span></h3>

    <div class="description">
GO-CAMs (Gene Ontology Causal Activity Models) are a framework
developed by the Gene Ontology (GO) project to represent complex
biological pathways in a structured, computable format.
    </div>

    <div class="description">
Below is a list of the {{modelCount}} current <span class="genus-species">S. pombe</span>
GO-CAM pathways with links to the process or processes that they model.
    </div>

    <div class="description">
(Not all pathway models are complete.  See the "Notes on Model Completeness"
section of the
<a routerLink="/documentation/gocams">PomBase GO-CAM documentation</a>
for more.)
    </div>

    <div class="project-scope">
      <app-gocam-project-scope></app-gocam-project-scope>
    </div>

    <app-go-cam-table></app-go-cam-table>
  </div>

  <div *ngIf="pageType && pageType == 'summary'" class="gocam-page">
    <h3>
      <span *ngIf="pageSubType == 'connected'">
        GO-CAM Summary Map - Connected Models Only
      </span>
      <span *ngIf="pageSubType != 'connected'">
        GO-CAM Summary Map - All Models
      </span>
      <span class="help-link">
        <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
          Documentation
        </app-help-link>
      </span>
    </h3>

    <div class="description">
      A high-level graphical summary of the connections between GO-CAM
      models.
    </div>

    <div class="description">
      Clicking on a pathway will display its title in the right-hand
      panel.  Click the title to open a new tab/window to view the
      pathway in detail.
    </div>
    <div class="description">
      Multiple pathways can be selected by shift-clicking or
      shift-click and drag in the map.  When multiple pathways are
      selected, click on "View joined models" to see connections
      between the models in detail.
    </div>

    <div *ngIf="pageSubType == 'connected'" class="description">
      Note: unconnected models are hidden (<a routerLink="/gocam/summary/all">show</a>)
    </div>
    <div *ngIf="pageSubType != 'connected'" class="description">
      Note: unconnected models are shown (<a routerLink="/gocam/summary/connected">hide</a>)
    </div>

    <div class="algorithm-select" *ngIf="devMode()">
      <input id="merge-by-chemical" type="checkbox" [(ngModel)]="mergeByChemical" (ngModelChange)="updateSummaryMapUrl()">
      <label for="merge-by-chemical">Merge by chemical</label>
    </div>

    <div *ngIf="iframeUrl" class="gocam-container">
      <iframe [src]="iframeUrl" class="gocam-iframe" #gocamiframe>
      </iframe>
    </div>
  </div>

  <div *ngIf="pageType && pageType == 'mega-model'" class="gocam-page">
    <h3>
      <span *ngIf="pageSubType == 'connected'">
        GO-CAM Mega Model - Connected Models Only
      </span>
      <span *ngIf="pageSubType != 'connected'">
        GO-CAM Mega Model - All Models
      </span>

      <span class="help-link">
        <app-help-link [route]="'/documentation/gocams'"
                       [title]="'GO-CAM documentation'">
          Documentation
        </app-help-link>
      </span>
    </h3>

    <div class="description">
      This is a combined model created using the
      <a routerLink="/gocam/connections">Model joining activities</a>.
    </div>

    <div class="description">
      <span *ngIf="pageSubType == 'connected'">
        Note: unconnected models are hidden (<a routerLink="/gocam/mega-model/all">show</a>)
      </span>
      <span *ngIf="pageSubType != 'connected'">
        Note: unconnected models are shown (<a routerLink="/gocam/mega-model/connected">hide</a>)
      </span>
    </div>

    <div class="filter-group">
      <div class="filter-select">
        <input id="show-chemicals" type="checkbox" [(ngModel)]="showChemicals" (ngModelChange)="updateMegaModelUrl()">
        <label for="show-chemicals">Show chemicals</label>
      </div>

      <div class="filter-select">
        <input id="show-all-inputs" type="checkbox" [(ngModel)]="showTargets" (ngModelChange)="updateMegaModelUrl()">
        <label for="show-all-inputs">Show target genes/complexes</label>
      </div>
    </div>

    <div class="filter-select">
      <input id="show-models-boxes" type="checkbox" [(ngModel)]="showModelBoxes" value="true" (ngModelChange)="updateMegaModelUrl()">
      <label for="show-models-boxes">Show model boundaries</label>
    </div>

    <div class="algorithm-select" *ngIf="devMode()">
      <input id="merge-by-chemical" type="checkbox" [(ngModel)]="mergeByChemical" (ngModelChange)="updateMegaModelUrl()">
      <label for="merge-by-chemical">Merge by chemical</label>
    </div>

    <div *ngIf="iframeUrl" class="gocam-container">
      <iframe [src]="iframeUrl" class="gocam-iframe" #gocamiframe>
      </iframe>
    </div>
  </div>

  <div *ngIf="pageType == 'connections'">

    <h3>Pathway joining activities
      <span class="help-link">
      <app-help-link [route]="'/documentation/gocams'"
                     [title]="'GO-CAM documentation'">
        Documentation
      </app-help-link>
      </span>
    </h3>

    <div class="description">
      This table shows the activities in common between models.  These
      shared activities are where models can be joined to give the
      <a routerLink="/gocam/summary/all">GO-CAM Summary Map</a>
      and the <a routerLink="/gocam/mega-model/connected">Mega Model</a>.
    </div>

    <app-gocam-overlaps-table></app-gocam-overlaps-table>

  </div>

  <div *ngIf="pageType == 'tools'" id="pathway-tools">
    <h3>GO-CAM pathway tools
      <span class="help-link">
        <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
          Documentation
        </app-help-link>
      </span>
    </h3>

    <div>
      <h4>View pathway coverage for a list of genes</h4>

      <div class="description">
All pathways will be queried for your genes.  Then follow the
"Highlight in pathway" for GO-CAM models of interest.
      </div>

      <div>
Note: this functionality is also available to use with any
list in the <a routerLink="/query">Advanced Search</a>.
<p>
Look out for the "Visualise" menu at the top left of all gene results
pages.
</p>
      </div>

      <details open>
        <summary>
Enter gene identifier or names
        </summary>

        <app-gene-list-lookup [lookupFieldType]="'id-and-name'"
                              [lookupButtonLabel]="'View pathways'"
                              [exampleListQueryId]="'genes_with_rna_levels_increased_during_cesr'"
                              (genesFound)="pathwayGenesFound($event)"></app-gene-list-lookup>
      </details>
    </div>

    <hr/>

    <div>
      <h4>Highlight genes from a list in the Mega Model</h4>
      <div class="description">
The relevant parts of the Mega Model will be displayed, with your
genes in bold.
      </div>

      <details open>
        <summary>Enter gene identifier or names</summary>
        <app-gene-list-lookup [lookupFieldType]="'id-and-name'"
                              [lookupButtonLabel]="'View in Mega Model'"
                              [exampleListQueryId]="'genes_with_rna_levels_increased_during_cesr'"
                              (genesFound)="megaModelGenesFound($event)"></app-gene-list-lookup>
      </details>
    </div>
  </div>

  <div *ngIf="pageType == 'missing-activities'">
    <h3>Missing activities
      <span class="help-link">
      <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
        Documentation
      </app-help-link>
      </span>
    </h3>

    <div class="description">
      A list of {{getMissingActivityCount() | async}} activities known or suspected to occur in fission
      yeast but not yet associated with a gene product.  These
      "pathway holes" have been identified through
      <a routerLink="/gocam">GO-CAM causal model curation</a>.
    </div>

    <app-gocam-holes-table></app-gocam-holes-table>

  </div>

  <div *ngIf="pageType == 'pathway-metrics'">
    <h3>GO-CAM metrics: Network, term and gene level
      <span class="help-link">
        <app-help-link [route]="'/documentation/gocams'" [title]="'GO-CAM documentation'">
          Documentation
        </app-help-link>
      </span>
    </h3>

    <div class="description">

    </div>

    <app-gocam-total-stats></app-gocam-total-stats>

  </div>
  </div>
</div>
